import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Typography } from "@mui/material";

interface BottomSheetHeaderProps {
  title: React.ReactNode;
  titlePrefix?: string;
  onBack?: () => void;
  rightAction?: React.ReactNode;
}

export default function BottomSheetHeader({
  title,
  titlePrefix,
  onBack,
  rightAction,
}: BottomSheetHeaderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 16px",
        backgroundColor: "white",
        minHeight: 48,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          fontSize: "1rem",
          color: "text.primary",
          flex: 1,
        }}
      >
        {titlePrefix && (
          <Box
            component="span"
            sx={{ color: "text.secondary", fontWeight: 400 }}
          >
            {titlePrefix}{" "}
          </Box>
        )}
        {title}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {onBack && (
          <IconButton
            onClick={onBack}
            size="small"
            sx={{
              backgroundColor: "#F1EFF7",
              color: "#7D5DA3",
              "&:hover": {
                backgroundColor: "#E5E1F0",
              },
            }}
          >
            <ArrowBackIcon fontSize="small" />
          </IconButton>
        )}
        {rightAction}
      </Box>
    </Box>
  );
}
